import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-up': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9l194.3-194.4c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9l-22.2 22.2c-9.5 9.5-25 9.3-34.3-0.4l-114.7-120.4v287.4c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24v-287.4l-114.8 120.5c-9.3 9.8-24.8 10-34.3 0.4z'
      }
    ]
  }
})
